export interface SSESubscriptionControlProps {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  includeInitial: boolean;
  onIncludeInitialToggle: (include: boolean) => void;
  label?: string;
}

export function SSESubscriptionControl({
  enabled,
  onToggle,
  includeInitial,
  onIncludeInitialToggle,
  label = 'Real-time Updates',
}: SSESubscriptionControlProps) {
  return (
    <div className="flex items-center gap-3">
      {/* Subscribe Button */}
      <button
        onClick={() => onToggle(!enabled)}
        className={`flex items-center gap-2 px-3 py-2 rounded-md border transition-colors ${
          enabled
            ? 'bg-green-50 dark:bg-green-900/20 border-green-300 dark:border-green-700 text-green-700 dark:text-green-300'
            : 'bg-gray-50 dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:border-gray-400 dark:hover:border-gray-500'
        }`}
        title={enabled ? 'Disable real-time updates' : 'Enable real-time updates'}
      >
        {/* Status Icon */}
        <div
          className={`w-2 h-2 rounded-full transition-colors ${
            enabled ? 'bg-green-500 animate-pulse' : 'bg-gray-400'
          }`}
        />
        <span className="text-sm font-medium">{label}</span>
      </button>

      {/* Include Initial Data Toggle - Always visible */}
      <label className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 cursor-pointer">
        <span>Include Initial</span>
        <button
          type="button"
          onClick={() => onIncludeInitialToggle(!includeInitial)}
          className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
            includeInitial
              ? 'bg-blue-600'
              : 'bg-gray-300 dark:bg-gray-600'
          }`}
          role="switch"
          aria-checked={includeInitial}
          title="Include initial data when connecting"
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              includeInitial ? 'translate-x-5' : 'translate-x-0.5'
            }`}
          />
        </button>
      </label>
    </div>
  );
}

